import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, EventEmitter, Input, Output, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Constant } from 'src/app/constant/constant';
import { ConfigService } from 'src/app/services/config.service';
import { WindowRefService } from 'src/app/services/window-ref.service';
import { environment } from 'src/environments/environment';
 import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnDestroy {

  sanitizedUrl: string = '';

  url = '';


  key: any;
  @Input() disable: boolean = false;

  status:boolean = true;
  razorpayScriptLoaded: any=false;
  constructor(private winRef: WindowRefService,
    private configService:ConfigService,
    private ecryptService: EcryptServiceService
    , private router: Router) {
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
}

  @Input() finalAmount: any;

  @Input() partialAmountEnabled : any;

  @Input() contact: any;
  @Input() currency: string = 'INR';
  @Input() type: any=0;

  @Input() form: FormGroup;

  @Input() apiKey: string;

  @Output() paymentStatus: EventEmitter<any> = new EventEmitter<any>();

  @Output() valide: EventEmitter<any> = new EventEmitter<any>();
  ngOnInit() {
 
    this.getConfigdata();
    }
 

  loadRazorpayScript() {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    script.onload = () => {
      this.razorpayScriptLoaded = true; 
            // Razorpay script has loaded successfully
      // You can now use Razorpay functionalities
      // Call a method in your service to set up Razorpay
    };
    script.onerror = (error) => {
      // Handle script loading error, if any
      console.error('Error loading Razorpay script:', error);
    };

    // Append the script to the document's head
    document.head.appendChild(script);
  }





  createRzpayOrder() {
    console.log("here");
    
    this.payWithRazor();
  }
  
  public serverPath = environment.commonImageApi+"logo/";
  
  payWithRazor() {

    if(this.type==2){
      if(!this.form.valid){
        this.valide.emit("notValid");
        
      }else{
        this.openSheet()
      }
    }else{
      this.openSheet()

    }

  
  }

  
  additionData: string;
  paymentObject: any;
  emitResponse(response,options){
    let paymentInformation = {}

    if(this.partialAmountEnabled==1){
      paymentInformation = {
        razorpay_payment_id: response['razorpay_payment_id'],
        currency: options['currency'],
        Partial_Payment:'Yes',
        Partial_Paid_Amount:this.finalAmount
  
      }
    }else{
      paymentInformation = {
        razorpay_payment_id: response['razorpay_payment_id'],
        currency: options['currency'],
  
      }
    }
   

    this.additionData = JSON.stringify(paymentInformation)

    this.paymentObject = {
      salesPaymentTransaction: [{
        txn_id: response['razorpay_payment_id'],
        txn_type: "customer",
        isClose: true
      }],
      salesFlatOrderPayment: {
        method: 'razor_pay',
        additionalInformation: this.additionData

      },
      paypalPaymentStatus: "Successful"

    }

     this.paymentStatus.emit(this.paymentObject);
  }

  openSheet(){
    if( this.status){
      const options: any = {
        key: this.apiKey,
        amount: Math.round(this.finalAmount)*100,
        currency: this.currency || 'INR',
        name: Constant.siteName,
        description: 'Payment Transaction',
        prefill: {
          name: this.contact.name,
          contact: this.contact.contact,
          email: this.contact.email
        },
        modal: {
          // We should prevent closing of the form when esc key is pressed.
          escape: false,
        },
        notes: {
          address: "Razorpay Corporate Office"
        },
        theme: {
          color: "#3399cc"
        }
      };
      options.handler = ((response, error) => {
        options.response = response;
        this.emitResponse(response,options)
        // call your backend api to verify payment signature & capture transaction
      });
      options.modal.ondismiss = (() => {
        // handle the case when user closes the form while transaction is in progress
  
      });
      const rzp = new this.winRef.nativeWindow.Razorpay(options);
      rzp.open();
  
    }
  }

  getConfigdata() {
    this.configService.getKey().subscribe(
       (response:any) => {

          
          let configData = response;

        let config =response;

        if(response.encryptedText!=null){
     const decrypted = this.ecryptService.decryptionAES(response.encryptedText);
       configData = JSON.parse(decrypted);
        }

        let data =configData;
       
        this.apiKey=data['razorPayKey']

        if (!this.razorpayScriptLoaded) {

          if(this.apiKey==undefined){

            this.apiKey='rzp_live_2qkW2u5LNsmznp';
          }
          this.loadRazorpayScript();
        }

      }
    )
  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
